<template>
  <div>
    <div style="height: 40px; display: flex; align-items: center">
      <div class="work_title_color"></div>
      <span class="work_title"> 订单近30天数量统计 </span>
    </div>
    <div class="statisticChart"></div>
  </div>
</template>

<script>
import { GetStoreOrderNumMonthStatistics } from "@/api/storeOrderApi.js";
import * as echarts from "echarts";
export default {
  data() {
    return {
      loading: false,
      statisticData: {
        dayList: [],
        numList: [],
      },
    };
  },
  components: {},

  created() {
    this.GetStoreOrderNumMonthStatistics();
  },

  mounted() {
    this.initChart();
  },

  methods: {
    //初始化柱状图
    initChart() {
      // 获取图表容器
      const chartDom = document.querySelector(".statisticChart");
      // 初始化echarts实例
      this.chart = echarts.init(chartDom);

      // 设置图表选项
      const option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        title: {
          text: "订单数量统计柱状图",
          subtext: "近30天",
          left: "center",
          textStyle: {
            color: "#333",
            fontSize: 18,
          },
        },
        grid: {
          left: "2%",
          right: "4%",
          bottom: "2%",
          containLabel: true,
        },
        xAxis: {
          name: "日期",
          type: "category",
          data: this.statisticData.dayList,
          axisLabel: {
            interval: 0,
            rotate: 30,
          },
        },
        yAxis: {
          type: "value",
          name: "订单数量",
        },
        series: [
          {
            name: "订单数量",
            type: "bar",
            data: this.statisticData.numList,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: "#409eff",
                },
                {
                  offset: 1,
                  color: "#73c0de",
                },
              ]),
            },
            emphasis: {
              itemStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: "#2a6fc9",
                  },
                  {
                    offset: 1,
                    color: "#409eff",
                  },
                ]),
              },
            },
            label: {
              show: true,
              position: "top",
            },
          },
        ],
      };

      // 设置图表选项
      this.chart.setOption(option);

      // 监听窗口大小变化，调整图表大小
      window.addEventListener("resize", () => {
        this.chart.resize();
      });
    },
    //获取统计护具
    GetStoreOrderNumMonthStatistics() {
      let param = {};
      let userdata = JSON.parse(localStorage.getItem("userdata"));
      let roleList = process.env.VUE_APP_SEE_ALL_DATA;
      if (roleList.includes(userdata.userInfo.deptCode)) {
        param.keyId = userdata.userInfo.deptCode;
      }
      GetStoreOrderNumMonthStatistics(param).then((res) => {
        if (res.code == 1) {
          if (res.data) {
            this.statisticData.dayList = [];
            this.statisticData.numList = [];
            let list = res.data.dtls;
            list.forEach((item) => {
              this.statisticData.dayList.push(item.dateStr);
              this.statisticData.numList.push(item.count);
            });
            // 数据更新后刷新图表
            if (this.chart) {
              this.chart.setOption({
                xAxis: {
                  data: this.statisticData.dayList,
                },
                series: [
                  {
                    data: this.statisticData.numList,
                  },
                ],
              });
            }
          }
        } else {
          this.$message({
            type: "info",
            message: res.msg,
          });
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.work_title_color {
  width: 5px;
  height: 20px;
  background-color: #409eff;
  display: inline-block;
  padding: 0;
  margin: 0;
}
.work_title {
  font-size: 16px;
  font-weight: 700;
  font-family: 微软雅黑;
  padding: 0;
  margin: 0;
  margin-left: 10px;
  display: inline-block;
}
.statisticChart {
  width: 100%;
  height: 400px;
  margin-top: 20px;
}

.statisticItem {
  width: 210px;
  height: 100px;
  display: inline-block;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: space-around;

  .item_img {
    width: 100px;
    height: 100px;
    border-radius: 15px;
    display: inline-block;

    img {
      width: 60px;
      height: 60px;
      margin: 20px;
    }
  }
  .item_data {
    text-align: center;
    margin-left: 10px;
  }
  .item_Title {
    font-size: 18px;
    font-weight: 600;
    padding-bottom: 4px;
    color: rgba(7, 6, 6, 0.63);
  }
  .item_Num {
    font-size: 24px;
    font-weight: 600;
    padding-bottom: 4px;
    height: 60px;
    align-content: center;
  }
}
</style>